/**
 * OSTASIENSPIELE SHANGHAI 等活动入口承载页（中英文切换 + 跳转）
 */
const activityOstenRoutes = [
  {
    path: '/activity-osten',
    redirect: '/activity-osten/home'
  },
  {
    path: '/activity-osten/home',
    name: 'ActivityOstenHome',
    meta: { title: 'OSTASIENSPIELE SHANGHAI 2026' },
    component: () => import('@/views/activity-osten/home.vue')
  },
  {
    path: '/activity-osten/sub/:sport',
    name: 'ActivityOstenSubSelect',
    meta: { title: 'OSTASIENSPIELE SHANGHAI 2026' },
    component: () => import('@/views/activity-osten/sub-select.vue')
  }
]

export default activityOstenRoutes
